export default __webpack_public_path__ + "static/media/qr-code-1.f2929c9e.svg";